import { createRequestHelper } from '@utils/swr'
import { type HasPasswordRequest } from '../types/apiRequest'
import { type HasPasswordResponse } from '../types/apiResponse'
import { type CosignApis } from '../types/apis'

const {
  useRequest,
} = createRequestHelper<CosignApis['get']['wordpressPasswordExist'], HasPasswordResponse, HasPasswordRequest>({
  client: 'cosign',
  key: '/api/platform-sdk/wordpress-password-exist',
  fetcher: client => (url, params) => {
    return client.post(url, params)
  },
})

export const useApiWordpressPasswordExist = useRequest
